import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import Model from "./Model";
export class Stripe extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "name", {
      fieldName: 'name',
      content: null
    });
    _defineProperty(this, "mode", {
      fieldName: 'mode',
      content: null
    });
    _defineProperty(this, "publicLiveKey", {
      fieldName: 'live_public_key',
      content: null
    });
    _defineProperty(this, "privateLiveKey", {
      fieldName: 'live_private_key',
      content: null
    });
    _defineProperty(this, "publicTestKey", {
      fieldName: 'test_public_key',
      content: null
    });
    _defineProperty(this, "privateTestKey", {
      fieldName: 'test_private_key',
      content: null
    });
    _defineProperty(this, "activityStatus", {
      fieldName: 'is_active',
      content: null
    });
    _defineProperty(this, "customData", {
      fieldName: 'custom_data',
      content: false
    });
  }
  getId() {
    return this.Id.content;
  }
}
_defineProperty(Stripe, "LIVE_MODE", 'live');
_defineProperty(Stripe, "TEST_MODE", 'test');
export default Stripe;